import React, { useEffect, useState } from 'react'
import { ChromePicker } from 'react-color'
import delayedAction from '../utils/delayedAction'
import { ReactComponent as IconTextColor } from '../assets/icons/custom/TextColor.svg'

const ColorSettings = ({
    canvas,
    activeSelection,
    drawColor,
    setDrawColor,
    activeTool
}) => {
    // console.log('activeTool:',activeTool)
    const [border, setBorder] = useState({
        width: 0,
        style: { strokeDashArray: [], strokeLineCap: 'square' },
        corner: '',
        color: 'rgba(218,218,218)'
    })
    const [borderColorPicker, setBorderColorPicker] = useState(false)
    const [colorPicker, setColorPicker] = useState('rgba(0, 0, 0, 1)')
    const [backgroundColor, setBackgroundColor] = useState(
        'rgb(218, 218, 218, 1)'
    )
    const [colorType, setColorType] = useState('')
    const [isFillColor, setIsFillColor] = useState(false)
    const [isBorderColor, setIsBorderColor] = useState(false)

    const clickFillCOlor = (colorType, isFill) => {
        console.log('colorType:', isFill)
        //setColorType(colorType)
        if (!isFill) {
            setColorType(colorType)
            canvas
                ?.getActiveObject()
                .set('backgroundColor', 'rgba(255, 255, 255, 0)')
            canvas.requestRenderAll()
        }
        // if(isFill){
        //  //   setColorType(colorType)
        //     canvas?.getActiveObject().set('backgroundColor', 'rgba(255, 255, 255, 1)')
        //     canvas.requestRenderAll()
        // }
        //  setColorType(colorType)
        setIsBorderColor(false)
        setIsFillColor(isFill)
        setColorType(colorType)
    }
    const clickBorderColor = (colorType, isBorder) => {
        const target = canvas?.getActiveObject()
        console.log('Target-text-color:', target)
        if (!isBorder) {
            setColorType(colorType)
            canvas
                ?.getActiveObject()
                .set('borderColor', 'rgba(255, 255, 255, 0)')
            setBorder({
                ...border,
                color: 'rgba(218, 218, 218)'
            })
            canvas.requestRenderAll()
        } else {
            setBorder({
                ...border,
                color: target.borderColor
            })
        }
        setIsFillColor(false)
        setColorType(colorType)
        setIsBorderColor(isBorder)
    }
    const clickTextColor = (colorType) => {
        setIsBorderColor(false)
        setIsFillColor(false)
        setColorType(colorType)
    }

    const [colorTextPicker, setColorTextPicker] = useState(false)
    const [colorText, setColorText] = useState({
        width: 0,
        color: 'rgba(0,0,0,1)'
    })
    const [valueAofRgb, setValueAofRgb] = useState(false)

    const defaultColor =
        activeTool === 'draw' || activeTool === 'path'
            ? drawColor
            : 'rgba(218,218,218,1)'

    // useEffect(()=>{
    //     const setColor = `rgb(255, 255, 255, 1)`
    //     canvas?.getActiveObject().set('backgroundColor', setColor)
    //     canvas.requestRenderAll()
    // },[])

    useEffect(() => {
        let borderColor
        if (activeSelection && activeSelection[0]?.stroke) {
            borderColor = activeSelection[0]?.stroke
        } else if (
            activeSelection &&
            activeSelection[0] &&
            activeSelection[0]._objects &&
            activeSelection[0]._objects[0].stroke
        ) {
            borderColor =
                activeSelection &&
                activeSelection[0] &&
                activeSelection[0]._objects &&
                activeSelection[0]._objects[0].stroke
        } else if (activeSelection && activeSelection[0]?.borderColor) {
            borderColor = activeSelection && activeSelection[0]?.borderColor
        } else {
            borderColor = window.globalColor
        }
        const loadedBorder = {
            width: activeSelection && activeSelection[0]?.strokeWidth,
            style: {
                strokeDashArray: activeSelection?.strokeDashArray,
                strokeLineCap: activeSelection?.strokeLineCap
            },
            corner: activeSelection?.strokeLineJoin,
            color: borderColor
        }

        setBorder(loadedBorder)
    }, [activeSelection])

    const setActiveStyle = (styleName, value) => {
        const activeObject = canvas?.getActiveObject()

        if (!activeObject) return
        if (activeObject.isEditing && activeObject.type === 'CustomTextbox') {
            const selection = activeObject.getSelectionStyles()

            setColorText({
                ...colorText,
                color: value
            })
            const style = {}
            style[styleName] = value
            textConfiguration[styleName] = value
            activeObject.setSelectionStyles(
                style,
                activeObject.selectionStart,
                activeObject.selectionEnd
            )
            activeObject.setCoords()
        } else {
            activeObject.set(styleName, value)
        }
        canvas.requestRenderAll()
        canvas.calcOffset()
    }
    const handleTextColorChange = (color) => {
        const rgbaColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
        const activeObject = canvas?.getActiveObject()
        console.log('activeObject:', activeObject)

        if (activeObject?.type === 'CustomTextbox') {
            textConfiguration.fill = rgbaColor
            // Update local state for UI consistency
            setColorText({
                ...colorText,
                color: rgbaColor
            })

            // Apply changes based on editing state
            if (activeObject.isEditing && colorType === 'text-color') {
                // Apply color to the selected text or current cursor position
                setActiveStyle('fill', rgbaColor)
            } else if (!activeObject.isEditing && colorType === 'text-color') {
                canvas?.getActiveObject().set('textColor', rgbaColor)
                // Iterate over styles to update text color while preserving other styles
                const textLength = activeObject.text.length
                for (let i = 0; i < textLength; i++) {
                    // Ensure there's a styles object for manipulating individual character styles
                    if (!activeObject.styles) activeObject.styles = {}
                    if (!activeObject.styles[0]) activeObject.styles[0] = {}

                    // Check if the character at position i has a style object, create if not
                    if (!activeObject.styles[0][i]) {
                        activeObject.styles[0][i] = {}
                    }

                    // Update the fill color while keeping other styles intact
                    activeObject.styles[0][i].fill = rgbaColor
                }

                // If there's no specific style set, apply the fill color directly to the object
                if (Object.keys(activeObject.styles[0]).length === 0) {
                    activeObject.set('fill', rgbaColor)
                }
            }
            // Request a re-render of the canvas
            canvas.requestRenderAll()
            canvas.calcOffset()
        }
    }
    const handleBorderColorChange = (color) => {
        const rgbaColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
        const setColorBorder = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, 1)`

        if (setDrawColor) {
            setDrawColor(rgbaColor)
        }
        if (canvas?.getActiveObject()?.type === 'CustomTextbox') {
            canvas?.getActiveObject().set('borderColor', setColorBorder)
            textConfiguration.borderColor = setColorBorder
            canvas.requestRenderAll()
        }

        setBorder({
            ...border,
            color: setColorBorder
        })

        const activeObject = canvas?.getActiveObject()

        if (
            activeObject &&
            canvas?.getActiveObject()?.type !== 'CustomTextbox'
        ) {
            activeObject.set('stroke', rgbaColor)

            if (activeObject.type === 'CustomTextbox') {
                activeObject.set('fill', rgbaColor)
            }

            canvas.requestRenderAll()
            canvas.calcOffset()

            delayedAction(1200, () => {
                canvas.fire('object:modified')
            })

            // Handle group objects and their children
            if (activeObject.type === 'group') {
                activeObject.forEachObject((childObj) => {
                    childObj.set('stroke', rgbaColor)
                    if (
                        childObj.type === 'CustomTextbox' ||
                        childObj.label === 'arrow-line-both-side'
                    ) {
                        childObj.set('fill', rgbaColor)
                    }
                })
            }
        }
    }

    const handleBackgroundColorChange = (color) => {
        console.log('Color:', color)
        const setColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
        const activeObject = canvas?.getActiveObject()
        console.log('activeObject:', activeObject)

        if (canvas?.getActiveObject()?.type === 'CustomTextbox') {
            const setColorBackground = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, 1)`
            setBackgroundColor(setColorBackground)
            if (activeObject.isEditing) {
                // Apply color to the selected text or current cursor position
                setActiveStyle('textBackgroundColor', setColorBackground)
                canvas.requestRenderAll()
            } else {
                canvas
                    ?.getActiveObject()
                    .set('backgroundColor', setColorBackground)
                textConfiguration.backgroundColor = setColorBackground
                canvas.requestRenderAll()
            }
            canvas.requestRenderAll()
        }

        if (canvas?.getActiveObject()?.type !== 'CustomTextbox') {
            setActiveStyle('fill', setColor)
            setBackgroundColor(setColor)
        }

        delayedAction(1200, () => {
            canvas.fire('object:modified')
        })
    }

    useEffect(() => {
        const setPredefinedValue = async ({ target }) => {
            console.log('Target:', target)
            if (target?.get('type') === 'CustomTextbox' && !target.isEditing) {
                setColorText({
                    ...colorText,
                    color: target.textColor || textConfiguration.fill
                })

                setBorder({
                    ...border,
                    color: isBorderColor
                        ? target.borderColor
                        : `rgba(218, 218, 218, 1)`
                })

                setBackgroundColor(target.backgroundColor)
            }
            if (target?.get('type') === 'CustomTextbox' && target?.isEditing) {
                const selectedStyles = await fetchSelectedStylesAsync(target)
                if (selectedStyles.length > 0) {
                    const firstFillColor = selectedStyles[0].fill // 'fill' is used for color in Fabric.js text styles
                    const isFillConsistent = selectedStyles.every(
                        (style) => style.fill === firstFillColor
                    )

                    const firstBackgroundColor =
                        selectedStyles[0].textBackgroundColor // 'fill' is used for color in Fabric.js text styles
                    const isBackgroundConsistent = selectedStyles.every(
                        (style) =>
                            style.textBackgroundColor === firstBackgroundColor
                    )

                    if (isFillConsistent && colorType === 'text-color') {
                        setColorText({
                            ...colorText,
                            color: firstFillColor
                        })
                    } else if (isBackgroundConsistent && colorType === 'fill') {
                        setBackgroundColor(firstBackgroundColor)
                    } else {
                        console.log('Multiple colors in selection.')
                    }
                } else {
                    console.log('No styles found in selection.')
                }
            }
        }
        if (
            activeSelection ||
            canvas?.getActiveObject()?.get('type') === 'CustomTextbox'
        ) {
            canvas?.on('mouse:down', setPredefinedValue)
        }
        return () => {
            canvas?.off('mouse:down', setPredefinedValue)
        }
    }, [activeSelection])

    const fetchSelectedStylesAsync = async (target) => {
        return new Promise((resolve, reject) => {
            try {
                // Simulate a delay to mimic async behavior, such as a network request
                setTimeout(() => {
                    // Directly using target.getSelectionStyles might not require async handling,
                    // but you can adapt this to your needs, e.g., fetching data based on selected text
                    if (
                        target?.selectionStart !== undefined &&
                        target?.selectionEnd !== undefined
                    ) {
                        const selectedStyles = target.getSelectionStyles(
                            target.selectionStart,
                            target.selectionEnd,
                            true
                        )
                        resolve(selectedStyles)
                    } else {
                        resolve([])
                    }
                }, 500) // Simulate a 500ms async operation
            } catch (error) {
                reject(error)
            }
        })
    }
    const isFillShow = () => {
        const tool = canvas?.getActiveObject()?.type
        // console.log('Toll:',canvas?.getActiveObject()?.type)
        if (tool === 'Arrow' || tool === 'group' || tool === 'polyline')
            return false
        return true
    }

    // console.log('defaultColor:',defaultColor )
    // console.log('Border:',border)
    console.log(' canvas?.getActiveObject():', canvas?.getActiveObject())
    console.log('textConfiguration:', textConfiguration)
    const renderColorPicker = () => {
        if (colorType === 'fill' && isFillColor) {
            return (
                <div className='setting'>
                    <div className='label'>Fill Color</div>
                    <div className='function'>
                        <div className='input-color'>
                            <div
                                className='color'
                                onClick={() => setColorPicker(!colorPicker)}
                            >
                                <div
                                    className='fill'
                                    style={{ backgroundColor: backgroundColor }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className={
                            colorPicker
                                ? 'picker-holder visible'
                                : 'picker-holder'
                        }
                    >
                        <ChromePicker
                            width='100%'
                            color={backgroundColor || defaultColor}
                            onChange={handleBackgroundColorChange}
                        />
                    </div>
                </div>
            )
        } else if (colorType === 'border' && isBorderColor) {
            return (
                <div className='setting'>
                    {/* {canvas?.getActiveObject()?.type !== 'CustomTextbox' && ( */}
                    <div className='label'>Stroke Color</div>
                    {/* )} */}
                    {/* {canvas?.getActiveObject()?.type === 'CustomTextbox' && (
                        <div className='label'>Text Color</div>
                    )} */}
                    <div className='function'>
                        <div className='input-color'>
                            <div
                                className='color'
                                onClick={() =>
                                    setBorderColorPicker(!borderColorPicker)
                                }
                            >
                                <div
                                    className='fill'
                                    style={{ backgroundColor: border.color }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className={
                            borderColorPicker
                                ? 'picker-holder visible'
                                : 'picker-holder'
                        }
                    >
                        <ChromePicker
                            width='100%'
                            color={border.color || defaultColor}
                            onChange={handleBorderColorChange}
                        />
                    </div>
                </div>
            )
        } else if (colorType === 'text-color') {
            return (
                <div className='setting'>
                    {canvas?.getActiveObject()?.type === 'CustomTextbox' && (
                        <div className='label'>Text Color</div>
                    )}
                    <div className='function'>
                        <div className='input-color'>
                            <div
                                className='color'
                                onClick={() =>
                                    setColorTextPicker(!colorTextPicker)
                                }
                            >
                                <div
                                    className='fill'
                                    style={{ backgroundColor: colorText.color }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className={
                            colorTextPicker
                                ? 'picker-holder visible'
                                : 'picker-holder'
                        }
                    >
                        <ChromePicker
                            width='100%'
                            color={colorText.color || defaultColor}
                            onChange={handleTextColorChange}
                        />
                    </div>
                </div>
            )
        }
    }

    return (
        <>
            <div className='color-setting-section'>
                {isFillShow() && (
                    <div
                        onClick={() => clickFillCOlor('fill', !isFillColor)}
                        className={`color-single ${
                            colorType === 'fill' && isFillColor ? 'active' : ''
                        }`}
                    >
                        <span
                            className='fill-color-box'
                            style={{
                                background: backgroundColor || defaultColor,
                                border: `2px solid rgb(218, 218, 218)`
                            }}
                        />
                        <p className='color-title'>FILL</p>
                    </div>
                )}
                <div
                    // onClick={() => setColorType('border')}
                    onClick={() => clickBorderColor('border', !isBorderColor)}
                    className={`color-single ${
                        colorType === 'border' && isBorderColor ? 'active' : ''
                    }`}
                >
                    <span
                        className='border-color-box'
                        style={{
                            border: `2px solid ${border.color || defaultColor}`
                        }}
                    />
                    <p className='color-title'>STROKE</p>
                </div>
                {canvas?.getActiveObject()?.type === 'CustomTextbox' && (
                    <div
                        onClick={() => clickTextColor('text-color')}
                        className={`color-single color-text ${
                            colorType === 'text-color' ? 'active' : ''
                        }`}
                    >
                        <span>
                            <IconTextColor />
                        </span>
                        <p className='color-title'>TEXT</p>
                    </div>
                )}
            </div>
            {renderColorPicker()}
        </>
    )
}

export default ColorSettings
